import { deleteNotification } from '../utils/utility'

export const initState = {
  loading: false,
  auth: false,
  user: null,
  invoice: null,
  error: false
  //   loading: false,
};
export const reducer = (state, action) => {
    // console.log("From context Reducer", action);
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_AUTH":
      return { ...state, auth: action.payload };
    case "SET_INVOICE":
      return { ...state, invoice: action.payload };
    case "SET_ERROR":
      return { ...state, error: action.payload }
    case "DELETE_NOTIFICATION":
      const userWithRemovedNotification = deleteNotification(state.user, action.payload);
      return {
        ...state,
        user: userWithRemovedNotification
      }

    default:
      return state;
  }
};
